import React from "react";
import { LazyLoadRoutes } from "routes/lazyLoadRoutes";
import { Route } from "react-router-dom";
import {
  MOBILE_APP_ROUTE_IDS,
  MOBILE_APP_ROUTE_KEYS,
} from "./MobileAppVisibility.constants";

const MobileAppVisibility = React.lazy(() =>
  import("../MobileAppVisibility").then((module) => ({
    default: module.MobileAppVisibility,
  }))
);

export const MOBILE_APP_CUSTOM_ROUTES = [
  <Route
    exact
    key={MOBILE_APP_ROUTE_IDS[MOBILE_APP_ROUTE_KEYS.home]}
    path={MOBILE_APP_ROUTE_IDS[MOBILE_APP_ROUTE_KEYS.home]}
    render={(props) => (
      <LazyLoadRoutes props={props} LazyElement={MobileAppVisibility} />
    )}
  />,
];
